module.exports = __webpack_public_path__ + "static/media/icon-user.f7a481dc.svg";